import { useEffect, useState } from 'react'
import { CurecallSelect, CurecallSelectItem } from '@honestica/curecall-ui'
import { useFormContext } from 'react-hook-form'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { TLocation } from 'src/types/others'

interface Props {
  label?: string
  name: string
  handleChange?: (locationId: number) => void
  className?: string
  isRequired?: boolean
  customErrorMessage?: string
  defaultLocationId?: number
}

type TLocationOption = CurecallSelectItem<number>

const SelectLocation = ({ label, name, customErrorMessage, isRequired, defaultLocationId }: Props) => {
  const { locations } = useCurrentProject()
  const methods = useFormContext()
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
    clearErrors,
  } = methods

  const [selectedLocation, setSelectedLocation] = useState<TLocationOption | undefined>(undefined)

  useEffect(() => {
    const alreadyDefinedLocationId = getValues(name)
    if (alreadyDefinedLocationId) {
      const locationFound = locations.find((location: TLocation) => location.id === alreadyDefinedLocationId)
      locationFound &&
        handleChangeLocation({
          label: locationFound.name,
          value: locationFound.id,
        })
      return
    }

    if (locations.length === 1 && locations[0]) {
      handleChangeLocation({
        label: locations[0].name,
        value: locations[0].id,
      })
      return
    }

    if (defaultLocationId) {
      const locationFound = locations.find((location: TLocation) => location.id === defaultLocationId)
      locationFound &&
        handleChangeLocation({
          label: locationFound.name,
          value: locationFound.id,
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations.length])

  const handleChangeLocation = (newLocation: TLocationOption) => {
    setSelectedLocation(newLocation)
    setValue && setValue(name, newLocation.value)
    clearErrors(name)
  }

  const errorMessage =
    customErrorMessage ||
    'Merci de sélectionner le lieu de rendez-vous pour que nous puissions en informer le patient.'

  return (
    <>
      {locations?.length > 0 && (
        <CurecallSelect
          {...register(name, { required: isRequired && errorMessage })}
          label={label || "Lieu de l'intervention"}
          items={locations.map((location: TLocation) => ({
            label: location.name,
            value: location.id,
          }))}
          onChange={handleChangeLocation}
          selectedItem={selectedLocation}
          placeholder="Sélectionnez un lieu"
          isRequired={isRequired}
          errorMessage={errors && errors[name] && errorMessage}
        />
      )}
    </>
  )
}

export default SelectLocation
